import { Resource } from "src/app/core/jsonapi/resource";
import { prop } from "@rxweb/reactive-form-validators";

export type DialPlanActionTypeValue =
  | 'CallQueue'
  | 'CallExtension'
  | 'PlayAudio'
  | 'WaitForInput'
  | 'IsBusinessHours'
  | 'IsOnCallHours'
  | 'CallerIsWorker'
  | 'CallCaseProcessor'
  | 'CallCaseContractQueue'
  | 'CallerIsClient'
  | 'CallerIsCompany'
  | 'CallerIsExpert'
  | 'EndCall'
  | 'Wait'
  | 'SendDtmf'
  | 'ReadText'
  | 'SetCallerId'
  | 'CallerNumberIs'
  | 'CumpleHorario'
  | 'IsHoliday'
  | 'GoTo';

export const CONDITIONAL_ACTION_TYPES: DialPlanActionTypeValue[] = [
  'IsBusinessHours',
  'IsOnCallHours',
  'CallerIsWorker',
  'CallerIsClient',
  'CallerIsCompany',
  'CallerIsExpert',
  'CallerNumberIs',
  'CumpleHorario',
  'IsHoliday'
];

export const CALL_ACTION_TYPES: DialPlanActionTypeValue[] = [
  'CallQueue',
  'CallExtension',
  'CallCaseProcessor',
  'CallCaseContractQueue'
];

export class DialPlanAction extends Resource {
    public override type = 'dialPlanActions';

    @prop()
    public dialPlanId!: string;

    @prop()
    public parentBranchId?: string;

    @prop()
    public sortOrder!: number;

    @prop()
    public actionType!: DialPlanActionTypeValue;

    @prop()
    public queueId?: string;

    @prop()
    public extensionNumber?: string;

    @prop()
    public application?: string;

    @prop()
    public data?: string;

    @prop()
    public callerId?: string;

    @prop()
    public audioFilename?: string;

    @prop()
    public timeoutSeconds?: number;

    @prop()
    public maxDigits?: number;

    @prop()
    public waitSeconds?: number;

    @prop()
    public dtmfDigit?: string;

    @prop()
    public ttsText?: string;

    @prop()
    public callerIdName?: string;

    @prop()
    public callerNumber?: string;

    @prop()
    public startTime?: string;

    @prop()
    public endTime?: string;

    @prop()
    public daysOfWeek?: string;

    @prop()
    public targetActionId?: string;

    @prop()
    public positionX?: number;

    @prop()
    public positionY?: number;
}
